import { FormlyFieldConfig } from 'ng-formly';
export const formulaFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            placeholder: 'Name',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'formula',
        className: 'col-md-4',
        type: 'select-component',
        templateOptions: {
            label: 'Formula',
            required: true,
            options: [
                { label: 'ADD', value: 'ADD' },
                { label: 'ADD DAYS', value: 'ADDDAYS' },
                { label: 'ADD DAYS DUR', value: 'ADDDAYSDUR' },
                { label: 'ADD MONTHS', value: 'ADDMONTHS' },
                { label: 'ADD SUB', value: 'ADDSUB' },
                { label: 'ADD YEARS', value: 'ADDYEARS' },
                { label: 'AMT ADD', value: 'AMTADD' },
                { label: 'AMT ADD DIV', value: 'AMTADDDIV' },
                { label: 'AMT ADD DIV%', value: 'AMTADDDIVPERC' },
                { label: 'AMT ADD SUB', value: 'AMTADDSUB' },
                { label: 'AMT COPY', value: 'AMTCOPY' },
                { label: 'AMT DIV', value: 'AMTDIV' },
                { label: 'AMT DIV DAYS', value: 'AMTDIVDAYS' },
                { label: 'AMT DIV MONTHS', value: 'AMTDIVMONTHS' },
                { label: 'AMT DIV%', value: 'AMTDIVPERC' },
                { label: 'AMT DIV YEARS', value: 'AMTDIVYEARS' },
                { label: 'AMT DIV DAYS DUR', value: 'AMTDIVDAYSDUR' },
                { label: 'AMT MUL', value: 'AMTMUL' },
                { label: 'AMT MUL%', value: 'AMTMULPERC' },
                { label: 'AMT MUL% MULDAYS', value: 'AMTMULPERCMULDAYS' },
                { label: 'AMT MUL% MULDAYS DUR', value: 'AMTMULPERCMULDAYSDUR' },
                { label: 'YIELD', value: 'YIELD' },
                { label: 'YIELD%', value: 'YIELDPERC' },
                { label: 'AMT SUB', value: 'AMTSUB' },
                { label: 'AMT SUB DIV', value: 'AMTSUBDIV' },
                { label: 'AMT SUB DIV%', value: 'AMTSUBDIVPERC' },
                { label: 'CONCATENATE', value: 'CONCATENATE' },
                { label: 'COPY', value: 'COPY' },
                { label: 'CREDIT', value: 'CREDIT' },
                { label: 'CREDIT DEBIT', value: 'CREDITDEBIT' },
                { label: 'DATES DDMM', value: 'DATESDDMM' },
                { label: 'DEBIT', value: 'DEBIT' },
                { label: 'DIVIDE', value: 'DIVIDE' },
                { label: 'DURATION', value: 'DURATION' },
                { label: 'MULTIPLY', value: 'MULTIPLY' },
                { label: 'SUB', value: 'SUB' },
                { label: 'TODAY', value: 'TODAY' }
            ]
        }
    },
    {
        key: 'sortorder',
        className: 'col-md-4',
        type: 'input-field',
        hideExpression: '!model.entityId',
        defaultValue: 0,
        templateOptions: {
            type: 'number',
            label: 'Sort Order',
            required: true
        }
    },
    {
        key: 'condition',
        className: 'col-md-12',
        type: 'input-field',
        hideExpression: '!model.entityId',
        defaultValue: 'true',
        templateOptions: {
            type: 'text',
            label: 'Condition: Execute if true',
            required: true
        }
    },
    {
        key: 'fields',
        className: 'col-md-12',
        type: 'select-component',
        hideExpression: '!model.entityId',
        templateOptions: {
            type: 'entityfield',
            label: 'Input Fields',
            parent: 'currententity',
            multiple: true,
            required: true,
            savenames: true
        }
    },
    {
        key: 'results',
        className: 'col-md-12',
        type: 'select-component',
        hideExpression: '!model.entityId',
        templateOptions: {
            type: 'entityfield',
            label: 'Result Fields',
            parent: 'currententity',
            required: false,
            multiple: true,
            savenames: true
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: 'Description for the formula',
            required: true,
            label: 'Description'
        }
    }

];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/formula.ts